import React, { useState, useEffect, useRef } from "react";
import styles from "./Header.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faSearch, faUser, faEnvelope, faBuilding, faBars, faBell } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../hooks";

function Header({ currentPage, showSearchBar, onSearch, onHamburgerClick, isSidebarOpen }) {
	const { user, logout } = useAuth();
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const dropdownRef = useRef(null);

	const toggleDropdown = () => {
		setDropdownOpen(prev => !prev);
	};

	const handleLogout = () => {
		logout();
	};

	const handleSearch = (e) => {
		setSearchValue(e.target.value);
		onSearch?.(e);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<header className={styles.headerContainer}>
			<div className={styles.leftSection}>
				<h1>{currentPage}</h1>
				{showSearchBar && (
					<div className={styles.searchContainer}>
						<FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
						<input 
							type="text" 
							placeholder="Search..." 
							value={searchValue}
							onChange={handleSearch}
						/>
					</div>
				)}
			</div>
			<div className={styles.rightSection}>
				<button className={styles.bell} aria-label="Notifications">
					<FontAwesomeIcon icon={faBell} />
				</button>
				<div className={styles.avatar} onClick={toggleDropdown} tabIndex={0} role="button" aria-label="User menu">
					{user.avatarUrl ? (
						<img src={user.avatarUrl} alt="User avatar" />
					) : user.firstname && user.lastname ? (
						<span>{user.firstname.charAt(0)}{user.lastname.charAt(0)}</span>
					) : (
						<FontAwesomeIcon icon={faUser} />
					)}
				</div>
				{dropdownOpen && (
					<div className={styles.dropdown} ref={dropdownRef}>
						<div className={styles.userName}>
							{user.firstname} {user.lastname}
						</div>
						<div className={styles.userInfo}>
							<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
								<FontAwesomeIcon icon={faEnvelope} style={{ color: 'var(--color_icon)', fontSize: '0.9rem' }} />
								<span>{user.email}</span>
							</div>
							{user.account && (
								<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
									<FontAwesomeIcon icon={faBuilding} style={{ color: 'var(--color_icon)', fontSize: '0.9rem' }} />
									<span>{user.account.name}</span>
								</div>
							)}
						</div>
						<div className={styles.dropdownItem} onClick={handleLogout}>
							<FontAwesomeIcon icon={faSignOutAlt} className={styles.logoutIcon} />
							<span>Logout</span>
						</div>
					</div>
				)}
				<button
					className={styles.hamburger}
					onClick={onHamburgerClick}
					aria-label="Open sidebar menu"
					aria-expanded={isSidebarOpen}
					type="button"
				>
					<FontAwesomeIcon icon={faBars} />
				</button>
			</div>
		</header>
	);
}

export { Header };
